import React, { Component } from 'react';
import './nav.css';

class Nav extends Component {
	constructor(props) {
		super(props);
		this.load = this.load.bind( this );
		this.startSearch = this.startSearch.bind( this );
		this.showNav = this.showNav.bind( this );
		this.hideNav = this.hideNav.bind( this );
		
		this.state = {
			$html: null,
			"items": [],
			"visible": false
		}
	}
	
	componentDidMount() {
		this.load();
		this.setState(
			{ "$html": document.documentElement }
		);
	}
  
	componentDidUpdate( prevProps, prevState ) {
		//console.log( prevProps, this.props.Show );
		
		if ( prevProps.Show !== this.props.Show ) {
			if ( this.props.Show ) {
				this.setState(
					{ "visible": true },
					this.showNav
				);
			} else {
				this.hideNav();
			}
		}
	}
  
	componentWillUnmout() {
		clearTimeout( this.timeout );
	}
	
	showNav() {
		this.state.$html.classList.add( "nav-visible" );
		this.timeout = setTimeout(
			() => {
				this.state.$html.classList.add( "nav-in" );
				this.state.$html.classList.remove( "search-in" );
				this.state.$html.classList.remove( "search-visible" );
			},
			1
		);
	}
	
	hideNav() {
		this.state.$html.classList.remove("nav-in");
		this.timeout = setTimeout(
			() => {
				this.state.$html.classList.remove( "nav-visible" );
				this.setState( { "visible": false } );
			},
			this.props.AnimationDuration
		);
	}
	
	startSearch(e) {
		e.preventDefault();
		let keyword = document.querySelector('#search-keyword').value;
		if ( keyword && keyword.length > 2 ) {
			window.location.hash = '/filtra/' + escape(keyword);
			document.querySelector('#search-keyword').value = '';
		}
	}
	
	load() {
		this.props.FetchContent(
			this.props.BaseUrl + this.props.NavUrl,
			{},
			(data) => {
				this.setState( { "items": data.collections } );
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		var Location = this.props.Location;
		// if ( this.state.visible  ) {
			return (
				<nav className="main-nav">
					<div className="in">
						<ul className="nav-items">
							<li className="nav-title"><h2>Archivio News</h2></li>
						{
							this.state.items.map(
								function(item) {
									return <li key={item.id} className={ "nav-item " + ( ( Location === "#/categoria/" + item.slug  ) ? "active " : "" ) + item.slug }><a href={ "#/categoria/" + item.slug } ><span>{item.name}</span></a></li>
								}
							)
						}
							
							<li className="nav-title"><h2>Cerca nell'archivio</h2></li>
							<li className="nav-item search"><form onSubmit={this.startSearch}><input type="search" id="search-keyword" name="search-keyword" placeholder="Premi invio per cercare ↲" /></form></li>
							{ /*
							<li className="nav-title"><h2>Approfondimenti</h2></li>
							<li className="nav-item"><a href="#/timeline/">Timeline</a></li>
							<li className="nav-item"><a href="#/temi/">Temi</a></li>
							<li className="nav-item"><a href="#/analisi/">Analisi</a></li>
							<li className="nav-item"><a href="https://facciafaccia.elezioni.io/" rel="noopener" target="_faccia">Faccia a Faccia</a></li>
							*/ }
							<li className="nav-title"><h2>Scopri di più</h2></li>
							<li className="nav-item"><a href="https://facciafaccia.elezioni.io/" rel="noopener" target="_faccia">Faccia a Faccia</a></li>
							<li className="nav-item"><a href="#/leggi/come-funziona">Come funziona</a></li>
							<li className="nav-item"><a href="#/leggi/chi-siamo">Chi siamo</a></li>
							<li className="nav-item"><a href="https://www.facebook.com/elezioni.io/">Facebook</a></li>
							<li className="nav-item"><a href="https://twitter.com/elezioni_io">Twitter</a></li>
						</ul>
					</div>
				</nav>
			);
		// } else {
		//	return null;
		// }
	}
}

export default Nav;



// WEBPACK FOOTER //
// ./src/Elezioni/nav.js